import React from 'react'
import PropTypes from 'prop-types'

import clsx from 'clsx'

import { Box, Typography, makeStyles } from '@material-ui/core'

import { VerifiedUserOutlined } from '@material-ui/icons'

import styles from './styles'

const useStyles = makeStyles(styles)

const SafeEnvironment = ({ direction = 'row', textProps = {}, ...rest }) => {
  const classes = useStyles()

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection={direction}
      {...rest}
    >
      <VerifiedUserOutlined
        className={clsx(classes.icon, {
          [classes.iconRow]: direction === 'row',
        })}
      />
      <Typography color="textSecondary" {...textProps}>
        Você está em um ambiente seguro
      </Typography>
    </Box>
  )
}

SafeEnvironment.propTypes = {
  direction: PropTypes.oneOf(['row', 'column']),
  textProps: PropTypes.object,
}

export default SafeEnvironment
